export const openLiveChat = (bdId, bkColor) => {
    if (window._bcvmw) {
        const cacheTime = localStorage.getItem('_bc_chat_time') || 0;
        const time = +new Date();
        const cid = cacheTime > time ? localStorage.getItem('_bc_chat_cid') : undefined;
        window._bcvmw.chatWindow(
            {
                altText: '',
                bdid: bdId,
                element: '.bc-chat',
                embed: true,
                html: false,
                id: 'chat',
                img: 'http://images.boldchat.com/ext/images/buttons/chat/gallery/Button_Navy_Flat_1B.png',
                launchType: 'embed',
                type: 'chat',
                video: false
            },
            cid
        );
        setTimeout(() => {
            const col1 = document.getElementsByClassName('bc-frame-header');
            if(document.getElementById('custom-css')){
                return;
            }else {
                if(col1.length){
                    col1[0].style.background = `${bkColor}`;
                    var style = document.createElement('style');
                    style.innerText = `.bc-frame-header:after { border-top: .5em solid ${bkColor}!important }`;
                    document.body.appendChild(style);
                    col1[0].setAttribute('id', 'custom-css');
                }
            }
        }, 3000);
    }
};
